import {
  getGetCategoryContentQueryOptions,
  getGetEquityDetailContentQueryOptions,
  getGetETFDetailContentQueryOptions,
  getGetHomepageContentQueryOptions,
  getGetMutualFundDetailContentQueryOptions,
} from '#/api/generated/content/content';

/**
 * Cache policy for all editorial-content queries.
 *
 * Content changes on Drupal-edit cadence, not user cadence: fetch each
 * document once per session and never refetch (staleTime) or evict (gcTime).
 * Retries are short so a content outage settles fast — route loaders await
 * the full retry cycle before falling back (see CONTENT.md).
 */
export const CONTENT_CACHE_QUERY_POLICY = {
  staleTime: Infinity,
  gcTime: Infinity,
  retry: 1,
  retryDelay: 500,
} as const;

/**
 * Query options for the homepage content document. Route loaders and hooks
 * must both build options from this factory so query keys and cache policy
 * stay aligned.
 */
export const homepageContentOptions = () =>
  getGetHomepageContentQueryOptions({ query: CONTENT_CACHE_QUERY_POLICY });

/** Query options for the equity-detail content document. */
export const equityDetailContentOptions = () =>
  getGetEquityDetailContentQueryOptions({ query: CONTENT_CACHE_QUERY_POLICY });

/** Query options for the etf-detail content document. */
export const etfDetailContentOptions = () =>
  getGetETFDetailContentQueryOptions({ query: CONTENT_CACHE_QUERY_POLICY });

/** Query options for the mutual-fund-detail content document. */
export const mutualFundDetailContentOptions = () =>
  getGetMutualFundDetailContentQueryOptions({
    query: CONTENT_CACHE_QUERY_POLICY,
  });

/** Query options for a category content document, keyed by category slug. */
export const categoryContentOptions = (category: string) =>
  getGetCategoryContentQueryOptions(category, {
    query: CONTENT_CACHE_QUERY_POLICY,
  });
